export default __webpack_public_path__ + "static/video1-d903446b2c9ac50adb0135a783433c07.mp4";